import { Button } from '@design/components/button/Button';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../Shared.module.scss';

export interface ScenarioReadyToRunProps {
  assetsCount: number;
  conditionsCount: number;
  runConditionsOnClick: () => void;
}

export const ScenarioReadyToRun = ({
  assetsCount,
  conditionsCount,
  runConditionsOnClick,
}: ScenarioReadyToRunProps) => {
  const { t } = useTranslation('scenario');
  const { trackScenarioRan } = usePosthogEvents();

  const title = `${t('scenario:emptyState.assetsAnd', {
    count: assetsCount,
  })} ${t('scenario:emptyState.conditionsSelected', {
    count: conditionsCount,
  })}`;

  return (
    <div className={sharedStyles.container} data-testid="scenario-ready-to-run">
      <img
        className={sharedStyles.img}
        src="/app/static/images/icons/no-assets-found.svg"
        alt=""
      />
      <div className={sharedStyles.description}>
        <p className={sharedStyles.title}>{title}</p>
        <Button
          className={sharedStyles.styledButton}
          variant="primary"
          label={t('scenario:buttonLabels.runScenario')}
          data-testid="run-scenario"
          onClick={() => {
            trackScenarioRan(POSTHOG_TRACKING_SOURCES.SCENARIO);
            runConditionsOnClick();
          }}
        />
      </div>
    </div>
  );
};
